import { TextField } from '@mui/material';
import React, { useState } from 'react';
import '../../components/app/common.scss';


function CustomTextField({ placeholder = '', label='', type = 'text', name, parent = undefined, prop = undefined, helperText = undefined, value= undefined, multiline = false, rows = 1,
className = 'textfield-input-wrp', onChange = undefined, variant = undefined, required = false, inputProps = undefined , max = undefined  }) {
    const [inputText, setInputText] = useState(value);
    const [titleChars, setTitleChars] = useState(inputText?.length);
    const handleInputChange = (e, onChange) => {
        e.preventDefault();
        if(parent) {
            parent[prop || 'value'] = e.target.value;
        }
        onChange(e);
        setTitleChars(e.target.value.length);
        setInputText(e.target.value);
    }

    return (
        <div className={'textfield '+className}>
            <label>{label}</label>
            <TextField 
                name={name}
                className={className}
                placeholder={placeholder}
                multiline={multiline}
                variant={variant}
                type={type}
                error={helperText}
                helperText={helperText}
                required={required}
                fullWidth
                value={value ? value : inputText}
                rows={rows}
                inputProps = {inputProps}
                onChange={(e) => handleInputChange(e, onChange)}
            />
            {titleChars && type === 'text' && (inputProps?.maxLength || inputProps?.minLength) ? <div className='char-count'>{titleChars} of {inputProps?.minLength || inputProps?.maxLength} {inputProps?.minLength && 'Minimum'} Characters</div> : ''}
        </div>
    );
}

export default CustomTextField;